<script setup>
import { ref, onBeforeUnmount, onBeforeMount } from "vue";
import { post } from '@/helpers/api'
import authStore from "../store/auth";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import backgroundImage from "../assets/img/invoice-main.jpg";
const body = document.getElementsByTagName("body")[0];

const backgroundStyle = {
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
};

const store = useStore();
const router = useRouter();

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const email = ref("");
const password = ref("");
const rememberMe = ref(false);
const errorMessage = ref(""); 

const clearForm = () => {
  email.value = "";
  password.value = "";
  rememberMe.value = false;
  errorMessage.value = "";
};

const handleSubmit = async () => {
  errorMessage.value = "";
  const formData = {
    email: email.value,
    password: password.value,
    rememberMe: rememberMe.value,
  };

  await post("/company-login", formData)
    .then((response) => {
      if (response.data.status == "success") {
        authStore.set(
          response.data.data.token,
          JSON.stringify(response.data.data.user),
          response.data.data.company_id,
          response.data.data.company_name
        );

        clearForm();
        router.push("/dashboard");
      } else {
        errorMessage.value = response.data.message || "Login failed. Please try again.";
      }
    })
    .catch((error) => {
      errorMessage.value = error.response?.data?.message || "An error occurred. Please try again.";
      console.log(error);
    });
};
</script>
<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">Enter your email and password to sign in</p>
                </div>
                <div class="card-body">
                  <div v-if="errorMessage" class="alert alert-danger">
                    {{ errorMessage }}
                  </div>
                  <form role="form" @submit.prevent="handleSubmit">
                    <div class="mb-3">
                      <argon-input
                        id="email"
                        type="email"
                        placeholder="Email"
                        name="email"
                        size="lg"
                        v-model="email"
                      />
                    </div>
                    <div class="mb-3">
                      <argon-input
                        id="password"
                        type="password"
                        placeholder="Password"
                        name="password"
                        size="lg"
                        v-model="password"
                      />
                    </div>
                    <argon-switch
                      id="rememberMe"
                      name="remember-me"
                      v-model="rememberMe"
                      >Remember me</argon-switch
                    >

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="info"
                        fullWidth
                        size="lg"
                        type="submit"
                        >Sign in</argon-button
                      >
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Forgot your password?
                    <a
                      href="javascript:;"
                      class="text-warning text-gradient font-weight-bold"
                      >Reset</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="backgroundStyle"
              >
                <span class="mask opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >
                  EZ Bill
                </h4>
                <p class="text-white position-relative">
                  Manage invoices with ease
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
